<template>
  <div>
    <div class="guestbook-footer">
      <div v-on:click="editThis()" class="editIcon">
        <v-icon class="icon" name="pencil-alt" scale="1.5"></v-icon>
      </div>
      <div class="w3-display-container">
        <picture 
          class="mySlides" 
          v-for="(image, key) in imageFooter"
          :key="key"
          style="display: none"
        >
          <source :srcset="image.replace('desktop', 'mobile').replace('desktop-1000', 'mobile-375')"
                  media="(max-width: 699px)">
          <img :src="image"/>
        </picture>
        <button
          class="w3-button w3-color w3-display-left"
          v-on:click="switchImage(-1)"
        >
          &#10094;
        </button>
        <button
          class="w3-button w3-color w3-display-right"
          v-on:click="switchImage(1)"
        >
          &#10095;
        </button>
      </div>
    </div>
    <transition name="fadeInModal">
      <footer-edit v-if="showFooterEdit" @close="closeEdit"></footer-edit>
    </transition>
  </div>
</template>

<script>
import FooterEdit from "./FooterEdit";

export default {
  components: {
    FooterEdit,
  },
  props: {
    imageFooter: Array,
  },
  data() {
    return {
      slideIndex: 1,
      showFooterEdit: false,
    };
  },
  watch: {
    imageFooter: {
      deep: true,
      immediate: true,
      handler() {
        setTimeout(() => this.switchImage(0), 100);
      },
    },
  },
  // Moved to watch with immediate to run again if array updated
  // mounted () {
  //   setTimeout(() => this.showDivs(this.slideIndex), 500);
  // },
  methods: {
    switchImage: function (n) {
      let carouselImages = document.getElementsByClassName("mySlides");
      let arrayLength = carouselImages.length;
      carouselImages[this.slideIndex - 1].style.display = "none";

      if (this.slideIndex + n > arrayLength) {
        this.slideIndex = 1;
      } else if (this.slideIndex + n < 1) {
        this.slideIndex = arrayLength;
      } else {
        this.slideIndex += n;
      }
      carouselImages[this.slideIndex - 1].style.display = "block";
    },
    editThis: function () {
      this.showFooterEdit = true;
      document.body.classList.add("modal-open");
    },
    closeEdit: function () {
      this.showFooterEdit = false;
      document.body.classList.remove("modal-open");
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.guestbook-footer {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  padding: 0 20px 20px 20px;
  position: relative;
  border-radius: 8px;
}
.guestbook-footer img {
  border-radius: 8px;
  width: 100%;
  height: 450px;
  object-fit: cover;
}

.w3-display-container {
  position: relative;
}
.gbfooter img {
  border-radius: 8px;
  width: 100%;
  max-height: 450px;
  object-fit: cover;
}
.w3-display-left {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(0%, -50%);
  -ms-transform: translate(-0%, -50%);
}
.w3-display-right {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.w3-button:hover {
  color: #000 !important;
  background-color: #ccc !important;
}
.w3-button {
  border: none;
  display: inline-block;
  border-radius: 4px;
  margin: 10px;
  padding: 8px 16px;
  vertical-align: middle;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background-color: inherit;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
}
.w3-color {
  color: #fff !important;
  background-color: #000 !important;
}

.editIcon {
  width: 48px;
  height: 48px;
  position: absolute;
  top: -15px;
  right: 5px;
  padding: 10px 14px;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  background-color: #3f3d39;
  min-height: 0px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

@media screen and (min-width: 700px) {
  .guestbook-footer {
    width: 700px;
    max-width: none;
  }
}

@media screen and (min-width: 1040px) {
  .guestbook-footer {
    width: 1040px;
  }
}
</style>
